import classNames from "classnames";
import React from "react";
import { DarkModeContext } from "../context/dark-mode-context";
import styles from "./loading.module.less";
export var Loading = function Loading() {
  return /*#__PURE__*/React.createElement(DarkModeContext.Consumer, null, function (isDarkMode) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.loading, isDarkMode && styles.darkMode)
    });
  });
};